var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.me)?_c('mentorship-employee',{attrs:{"id":+_vm.me.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }